import { Injectable, Injector } from '@angular/core';
import { TableListService } from 'app/common/table-list/table-list.service';
import { IRoutingParams } from 'app/common/models/context.model';
import { IWebhookModel } from '../../common/models/webhook.model';
import {IIntegrationModel} from '../../common/models/integration.models';
import {ICityModel} from '../../common/models/city-model';
import {IPagedList} from '../../common/models/common.models';

@Injectable()
export class IntegrationService extends TableListService<IIntegrationModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  getSingleItem(req: IRoutingParams) {
    return this.apiService.integration.getById(req.clubId);
  }

  save(model: IIntegrationModel) {
    return this.apiService.integration.save(model);
  }

  create(model: any): Promise<any> {
    return Promise.resolve(undefined);
  }

  getItemList(city?: ICityModel, pageIndex?: number, pageSize?: number, parentId?: string): Promise<Array<any> | IPagedList<any>> {
    return Promise.resolve(undefined);
  }
}
